import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/54350176/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { StructuredListWrapper, StructuredListHead, StructuredListRow, StructuredListCell, StructuredListBody, UnorderedList, ListItem } from 'carbon-components-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink"> Anatomy </AnchorLink>
      <AnchorLink mdxType="AnchorLink"> Requesting information </AnchorLink>
      <AnchorLink mdxType="AnchorLink"> Best practices </AnchorLink>
    </AnchorLinks>
    <h2>{`Anatomy`}</h2>
    <p>{`The following diagram outlines the primary components within the chatbot pattern.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "44.64285714285714%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVQoz4VSTWvCQBD1p/fWQwuF4m/wmBYKvZmTh2qhUKJgUhJjU6WJSQQ1m91NNq+z6wdKRQeGTZh5b2beTAs7a5rGvEo1qGqFY1Oy0gkmJoRAXdcH32P3+NYp4RYUTEL0+28YvA/g+z6ogskpWInfOMFqvQJjDFLKa4SErSp4ngfbtmF3u/DGY13HWFmWSNPUkH1RThiG2wkuEWpQEASI4xjFZoOaxq3WzMTSNMdsNkecJAim3/S/uN4h59yM6TgOPNdFlixQM2FijjuF9Wrj43OIh84TJr63010dSP8RatGXyyV6vR4sy8JoODpo+EPdPXaecdN+wd3tPZJ5tMXuCM+PTMK71FkURcjz3Ehw3P2G4kwQAS1PUvGmOt302Q6zLENRFMb1AvYgTrEV6Sl4aTYsSg4l5GVC/epk7VobRbemuDR3qO9OCG4uQX/r+DFW2x98vLT8ZOTh4QAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "chatbot 4",
        "title": "chatbot 4",
        "src": "/static/ceb4b74400230b108d02631bd8c9a432/3cbba/chatbot-4.png",
        "srcSet": ["/static/ceb4b74400230b108d02631bd8c9a432/7fc1e/chatbot-4.png 288w", "/static/ceb4b74400230b108d02631bd8c9a432/a5df1/chatbot-4.png 576w", "/static/ceb4b74400230b108d02631bd8c9a432/3cbba/chatbot-4.png 1152w", "/static/ceb4b74400230b108d02631bd8c9a432/0b124/chatbot-4.png 1728w", "/static/ceb4b74400230b108d02631bd8c9a432/99571/chatbot-4.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <StructuredListWrapper mdxType="StructuredListWrapper">
  <StructuredListHead mdxType="StructuredListHead">
    <StructuredListRow head mdxType="StructuredListRow">
      <StructuredListCell head mdxType="StructuredListCell">Component</StructuredListCell>
      <StructuredListCell head mdxType="StructuredListCell">Usage</StructuredListCell>
      <StructuredListCell head mdxType="StructuredListCell">Variants</StructuredListCell>
    </StructuredListRow>
  </StructuredListHead>
  <StructuredListBody mdxType="StructuredListBody">
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Chatbot header</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        The chatbot header contains the title of the chat and up to four action
        buttons that control the chatbot application. Typically, the “close”
        icon must always be included.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Default</ListItem>
          <ListItem mdxType="ListItem">With avatar</ListItem>
          <ListItem mdxType="ListItem">Large</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">System message</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        System Messages represent the bot's response to the user. Past messages
        will have a faded treatment, whereas active messages have an indicator
        applied (see below)
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Default</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">User message</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        A user message indicates what the user has input via text input,
        structured response, or voice.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Default</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Structured response</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        Structured responses present choices to the user that are easy for the
        bot to understand. When selected, a structured response will change its
        visual appearance and a user message will appear with the same content.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Default</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Chatbot input</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        The Chatbot input is comprised of a text input field, a configurable
        button for other input (e.g., voice) and a submit button.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Default</ListItem>
          <ListItem mdxType="ListItem">Without action button</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Launch button (not shown)</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        Launch buttons are the means by which a user initiates a conversation
        with your bot and are the first interaction of the bot experience.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Primary</ListItem>
          <ListItem mdxType="ListItem">Alternate</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Chatbot cards</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        Cards are used to display more information (including text and images)
        about a significant action that a user can take. They can also be used
        to display text and image together for a purely informational purpose.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Card with text (Hero)</ListItem>
          <ListItem mdxType="ListItem">Card with text (Large)</ListItem>
          <ListItem mdxType="ListItem">Card with text (Mini)</ListItem>
          <ListItem mdxType="ListItem">Card with image (Avatar)</ListItem>
          <ListItem mdxType="ListItem">Card with image (Large)</ListItem>
          <ListItem mdxType="ListItem">Card with image (Mini)</ListItem>
          <ListItem mdxType="ListItem">Card with data (Table)</ListItem>
          <ListItem mdxType="ListItem">Card with data (Visualization)</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
  </StructuredListBody>
    </StructuredListWrapper>
    <h2>{`Requesting information`}</h2>
    <p>{`The following flow shows a typical exchange between a user and a bot. This model can be used as a baseline to start building useful conversational experiences.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABNElEQVQoz5WSzWqEMBSF7Vi6GbqcWRX6AqXVTV9hWuhrdCdd+0I+gc/hxrXbgtQikvifxNuTGEsZCqMXLkdJ7sc5SRznrIjoyuo9+g39onuaplf0Cd+3y17f952LNY6Dq1WK8QPDVNc1SSnJlkiS5ITlfRiGN6ugRcndWeuANQMxXoum6ZQFdnmeP+v1KIrcVUDeTWYj66ZAE0ZFQigyQKVUD3lcjsbzvMuRiWYgBgyQcybRahgGwhn2iO/NRzPuVjlU6hzIAeSq73vjENAnvQ7dOWsKG3+BQggqy1JWVaUYY8gudORtQERx7UCgXeGWR4Ak/s2lbHa4ABHPPJu2bf8+GwWQZxNsAwLyjpgDHOaAfAHwDf2EPmxyWBSFUcD2aZrexXF8yLLsCNARrg8AXVvgv/M/Z7ZSMv/fwKkAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Requesting information from a chatbot",
        "title": "Requesting information from a chatbot",
        "src": "/static/3971374d16e1697d4d71cb890a6613c2/3cbba/chatbot-1.png",
        "srcSet": ["/static/3971374d16e1697d4d71cb890a6613c2/7fc1e/chatbot-1.png 288w", "/static/3971374d16e1697d4d71cb890a6613c2/a5df1/chatbot-1.png 576w", "/static/3971374d16e1697d4d71cb890a6613c2/3cbba/chatbot-1.png 1152w", "/static/3971374d16e1697d4d71cb890a6613c2/0b124/chatbot-1.png 1728w", "/static/3971374d16e1697d4d71cb890a6613c2/99571/chatbot-1.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2>{`Best practices`}</h2>
    <p>{`At a minimum, use these best practices to help ensure a successful conversational experience. For more in-depth conversational principles, see `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/ai/conversation"
      }}>{`IBM Design for Conversational AI`}</a>{`.`}</p>
    <h4>{`Introduction`}</h4>
    <p>{`Ensure your users know they are talking to a bot and that the bot has stated its purpose. Set the context for what questions users can ask about.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAAp0lEQVQoz62R4QqDMAyEff9HFP9acaND2yhtY70tGQ4nDoYauF5Dy8e1KbBT8zzLqs5TBnOSTvv3Gb726yp+A4HEEx6dg7V3hBgwjqPqODAleO9ARHDOqYiGc8AF5L1XH4YLgAK7FLjWaSCRV4hIUsp/ngK27Q1N06Cu69e0rU55gR0CVlWlKssSxhhNehjIzOj7Tp8aQkCMUX1772+geM75o22yPeATpmhkEn1Ub14AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Chatbot greeting",
        "title": "Chatbot greeting",
        "src": "/static/02c727b3289fc520636c5fb404856660/3cbba/chatbot-7.png",
        "srcSet": ["/static/02c727b3289fc520636c5fb404856660/7fc1e/chatbot-7.png 288w", "/static/02c727b3289fc520636c5fb404856660/a5df1/chatbot-7.png 576w", "/static/02c727b3289fc520636c5fb404856660/3cbba/chatbot-7.png 1152w", "/static/02c727b3289fc520636c5fb404856660/0b124/chatbot-7.png 1728w", "/static/02c727b3289fc520636c5fb404856660/99571/chatbot-7.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">chatbot greeting</Caption>
    <h4>{`User intent`}</h4>
    <p>{`Typically, a user inputs an intent, which can be request for information or a task for the bot to complete. This can take the form of a text (shown here) as well as a structured response (see next section)`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAAvUlEQVQoz62R3QqDMAyF974+guBD+Sp66Z0OL0ZLaetfaz1bIo45toF2gdMkpP1Imgs+2LIsdLL3c4D3jjLO1xp28atdvgMB52dIpSHEDeM0ou971nmgczBGw1oLrTXL2i4OuIGMMey77k/ATdFAGpcgpHVkGwGcHJrm+lCDuq4hpcQwDLtNH+6wqiqUZYmiKDhWSp3rkBRCQNu2yLIMaZoiSRLkec53qHa4Q+89b1cI8dx01B9uXb4//PWHd3z8XjHCgwoDAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "User Intent",
        "title": "User Intent",
        "src": "/static/3657a2a47a4fde852678725e5b5bac1c/3cbba/chatbot-8.png",
        "srcSet": ["/static/3657a2a47a4fde852678725e5b5bac1c/7fc1e/chatbot-8.png 288w", "/static/3657a2a47a4fde852678725e5b5bac1c/a5df1/chatbot-8.png 576w", "/static/3657a2a47a4fde852678725e5b5bac1c/3cbba/chatbot-8.png 1152w", "/static/3657a2a47a4fde852678725e5b5bac1c/0b124/chatbot-8.png 1728w", "/static/3657a2a47a4fde852678725e5b5bac1c/99571/chatbot-8.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">User intent</Caption>
    <h4>{`Structured responses`}</h4>
    <p>{`Prompt for additional details with a menu of structured responses. This narrows the scope to more specific information to answer the user’s question.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1klEQVQoz6VRWwqDQAz0zt5AvJPHUPDDDyuKFsQHLT7ZddWpSbHUYj/UQDYJWYaZjIadmOeZXq5qnKDUQBPP7x02/Xdo/wGBQY14PGuUZQEhBfq+5zwPOAxo22bJFnVdo6oq7i8BpmmKPM+QFzmapoEQYiP7MGAcx3AcB7Ztw3VdZFl2luGMaZqYoWmaMAwDuq7Dsiz+Q7vDDKWUCMNoyRBJcuc7kimXJPs3H0EQIIqixe3yA3jaFGLneR5XAuy67jygUoplrlLJ4UsuU6Xjrwb8stoDfAHx9Vxbd5/vTAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Structured Responses",
        "title": "Structured Responses",
        "src": "/static/59d021f4a53d3036625cffbce69be0cd/3cbba/chatbot-9.png",
        "srcSet": ["/static/59d021f4a53d3036625cffbce69be0cd/7fc1e/chatbot-9.png 288w", "/static/59d021f4a53d3036625cffbce69be0cd/a5df1/chatbot-9.png 576w", "/static/59d021f4a53d3036625cffbce69be0cd/3cbba/chatbot-9.png 1152w", "/static/59d021f4a53d3036625cffbce69be0cd/0b124/chatbot-9.png 1728w", "/static/59d021f4a53d3036625cffbce69be0cd/99571/chatbot-9.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Structured responses</Caption>
    <h4>{`Reflection`}</h4>
    <p>{`The bot should reflect its understanding of the query in the response (when appropriate) to ensure understanding, or before performing a significant action. Note: This process of slotfilling may need to be repeated until the bot has all the information required to answer the user’s initial question.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQoz6WSTQqDQAyFvf8FRLcWvIkLwbXgQrT+LKyOVUEdZ8bXzoAuxJZ2DIQsEj5eXmLgJNZ13SvjAkLwj/1jGN+AC+NoSIc8z/DsWjRNg77v95m/gZxzPKoKruvCcW6wbRu+76ueEEJD4bKgKAokSYIsy1DX9TWFEhjHsQKmaQpCCMZx3GHawDAMFVQCp2nSB1JKMc8zPM+DZVkwTRNBEFzwkC7vVe+IokiplD62bXvdw7IsFUgeZPNQ6w8ZYxiGQaVcfbPgOPczUFbp1ZbHY5wBX3WYWv9tcbRoAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Reflection",
        "title": "Reflection",
        "src": "/static/a8006c66705a45da9536b2daf310afa7/3cbba/chatbot-10.png",
        "srcSet": ["/static/a8006c66705a45da9536b2daf310afa7/7fc1e/chatbot-10.png 288w", "/static/a8006c66705a45da9536b2daf310afa7/a5df1/chatbot-10.png 576w", "/static/a8006c66705a45da9536b2daf310afa7/3cbba/chatbot-10.png 1152w", "/static/a8006c66705a45da9536b2daf310afa7/0b124/chatbot-10.png 1728w", "/static/a8006c66705a45da9536b2daf310afa7/99571/chatbot-10.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Reflection</Caption>
    <h4>{`Provide a response and request feedback`}</h4>
    <p>{`The bot should provide a thoughtful, informative response to the user’s intent, based on the information they have provided throughout the conversation. When appropriate, be sure to provide an opportunity for users to give feedback. Consider allowing the user to input a custom response. Provide an opportunity for users to give feedback where possible. Consider allowing the user to input a custom response.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAAxklEQVQoz6WS2Q6DIBBF/f8P9MUlPmhkadyigCLedmg0tbEPlUmGgZCcuZchwkVs20arr3Z1sNYe5/cdTvvPiH4DgcWuaNoB8iGgjcI0KSilAoDLgrIsUdcMnHP0fY95nk8q/wZKKdF1HbTWL3CNLMsCFM4LBBdgjHlwnueI4/g+kOwRJE1Tr4ygpDrI8g4risJbHscxbChJknggKSXrNOUddstyVVUQQqBpGrRtG6aQPvQwDD6NMb4B1dtvSNU5d+S31SvgE9C5YLX88M79AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Provide a response and request feedback",
        "title": "Provide a response and request feedback",
        "src": "/static/6ec5558ec899343bc16f9508de5604c4/3cbba/chatbot-11.png",
        "srcSet": ["/static/6ec5558ec899343bc16f9508de5604c4/7fc1e/chatbot-11.png 288w", "/static/6ec5558ec899343bc16f9508de5604c4/a5df1/chatbot-11.png 576w", "/static/6ec5558ec899343bc16f9508de5604c4/3cbba/chatbot-11.png 1152w", "/static/6ec5558ec899343bc16f9508de5604c4/0b124/chatbot-11.png 1728w", "/static/6ec5558ec899343bc16f9508de5604c4/99571/chatbot-11.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Provide a response and request feedback</Caption>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      